import { render, staticRenderFns } from "./after.vue?vue&type=template&id=71a1d450&scoped=true&"
import script from "./after.vue?vue&type=script&lang=js&"
export * from "./after.vue?vue&type=script&lang=js&"
import style0 from "./after.vue?vue&type=style&index=0&id=71a1d450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1d450",
  null
  
)

component.options.__file = "after.vue"
export default component.exports